import axios from 'axios';
import authHeader from "@/service/auth-header";

class HoldingsService {

    async getHoldingsForCompany(companyId, params, search, status, portfolio, category, type) {

        const newParams = {};

        if (params.sortField) {
            newParams.sortField = params.sortField;
        } else {
            newParams.sortField = "name";
        }

        if (params.sortOrder) {
            newParams.sortOrder = params.sortOrder;
        } else {
            newParams.sortOrder = "asc";
        }

        if (search) {
            newParams.search = search;
        }

        if (status) {
            newParams.status = status;
        }

        if (portfolio) {
            newParams.portfolio = portfolio;
        }

        if (category) {
            newParams.category = category;
        }

        if (type) {
            newParams.type = type;
        }

        newParams.page = params.first/params.rows + 1;
        newParams.size = params.rows;

        var apiString = `/api/holdings/${companyId}`;

        console.log("[HoldingService][getHoldingsForCompany]",
            "page =", newParams.page,
            ", size =", newParams.size,
            ", sort =", newParams.sortField,
            ", order =", newParams.sortOrder,
            ", search =", newParams.search,
            ", status =", newParams.status,
            ", portfolio =", newParams.portfolio,
            ", category =", newParams.category,
            ", type =", newParams.type,
            ", API =", apiString);

        try {
            const response = await axios.get(apiString, {
                headers: authHeader(),
                params: newParams
            });

            return {
                data: response.data,
                totalRecords: response.totalElements
            };
        } catch (error) {
            console.error("[HoldingsService][getHoldingsForCompany] API Error = ", error);
            return { data: [], totalRecords: 0 };
        }
    }


    async getHoldings(id) {
        return await axios.get(`/api/holdings/specific/${id}`, {headers: authHeader()})
    }

    async createHoldings(companyId, data) {
        return await axios.post(`/api/holdings/${companyId}`, data, {headers: authHeader()});
    }

    async updateHoldings(id, data) {
        return await axios.put(`/api/holdings/${id}`, data, {headers: authHeader()});
    }

    async deleteHoldings(id) {
        return await axios.delete(`/api/holdings/${id}`, {headers: authHeader()})
    }

}

export default new HoldingsService();
